import ga from '../utils/ga'

export const reportViewSurveyBanner = (surveyName) => {
  ga('send', 'event', 'Survey', 'View', surveyName, { nonInteraction: true })
}

export const reportStartSurveyClick = (surveyName) => {
  ga('send', 'event', 'Survey', 'click', surveyName)
}



// WEBPACK FOOTER //
// ./common/analytics/surveyBannerAnalytics.js